import { useState, useContext, useRef, memo, useMemo } from 'react';
import Button from '../buttons/Button';
import SummaryHeader from './SummaryHeader';
import SummaryTotalSlider from './SummaryTotalSlider';
import SummaryDetails from './SummaryDetails';
import { simulatorContext } from '../../service/SimulatorContext';
import { appContext } from '../../service/AppContext';
import { TOTAL_UNITS_PER_CHILD, distinctKidsCount } from '../../service/planUtils';

const Summary = memo(() => {

    const { user, isPending, setFetch, navigate, urlAgent } = useContext(appContext)
    const { summaryKids, completedKids, validKids, someChildIdInvalid } = useContext(simulatorContext);
    const [openDrawer, setOpenDrawer] = useState(false)

    const touchY = useRef(null)
    const summaryDrawerRef = useRef(null)
    const summaryInnerDrawerRef = useRef(null)

    const showDrawer = !!completedKids.length

    const toggleDrawer = () => {
        setOpenDrawer(prev => !prev);
        summaryInnerDrawerRef.current.scrollTo(0, 0);
    }

    const handleDragStart = (e) => {
        touchY.current = e.clientY

    }

    const handleDrag = (e) => {
        if (!e.clientY) {
            return
        }
        if (openDrawer && summaryInnerDrawerRef.current.contains(e.target))
            return
        if (!openDrawer && touchY.current > e.clientY) {
            setOpenDrawer(true)
        }
        if (openDrawer && touchY.current < e.clientY) {
            setOpenDrawer(false)
            summaryInnerDrawerRef.current.scrollTo(0, 0);
        }
    }

    const handleSubmit = () => {
        if (!isPending) {
            setFetch({
                route: '/unit-request',
                options: {
                    method: 'POST',
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        id: user?.id,
                        urlAgent,
                        kids: completedKids?.map(kid => { return { ...kid, plan: kid.plan?.route, planName: kid.plan?.title } })
                    })
                }
            })
            // Pass kids in grouped shape (multi plan rows) - registration regroups them into child cards
            navigate('/registration', { state: { user, completedKids: validKids, urlAgent, fromSimulator: true } })
        }

    }

    const maxUNits = useMemo(() => validKids?.reduce((max, kid) =>
        max + Math.min(TOTAL_UNITS_PER_CHILD, kid.plans.reduce((sum, row) => sum + (row.plan?.units ?? 0), 0)), 0), [validKids]);


    return (
        <section ref={summaryDrawerRef} className={`summary ${(openDrawer) ? 'show-mobile-summary' : ''}`} draggable="false" onDragStart={handleDragStart} onDrag={handleDrag} onTouchStart={(e) => handleDragStart(e.changedTouches[0])} onTouchMove={(e) => handleDrag(e.changedTouches[0])}>
            <SummaryHeader totalKids={distinctKidsCount(completedKids)} className={(showDrawer) ? 'show-drawer' : ''} openDrawer={openDrawer} toggleDrawer={toggleDrawer} />
            <div ref={summaryInnerDrawerRef} className={`summary-drawer ${(showDrawer) ? 'show-drawer' : ''}`}  >
                <div className="totals-wrapper" >
                    {/* disabled={!showDrawer}/> */}
                    <SummaryTotalSlider id="total-monthly-donation" label='סה"כ תרומה חודשית' units={summaryKids?.totalUnits} value={summaryKids?.totalMonthlyDonation} max={maxUNits} showUnits={true} onClick={toggleDrawer} disabled={true} />
                    <SummaryTotalSlider id="total-loans" label='סה"כ ההלוואות' units={summaryKids?.totalUnits} value={summaryKids?.totalLoan} max={maxUNits} disabled={true}/>
                </div>
                <SummaryDetails openDrawer={ openDrawer} />
            </div>
            <div className="summary-button-wrapper">
                <Button onClick={handleSubmit} className="wide-button gold-button" icon='check-circle' label='המשך' disabled={someChildIdInvalid} />
            </div>
        </section>
    )
});

export default Summary;